import { storage } from './platform/storage'

/**
 * Локальная отметка «диалог прочитан»: { [conversationId]: ISO timestamp }.
 * Порт mobile/lib/readState.ts на localStorage.
 *
 * Две правки против мобильной версии:
 *  - состояние чистится при выходе. В приложении устройство личное,
 *    а веб часто открывают на общем церковном компьютере, и отметки
 *    прочитанности утекали бы от одного человека к другому;
 *  - изменения из соседних вкладок подхватываются через событие storage.
 */

const STORAGE_KEY = 'lightchat_read_state_v1'

type ReadMap = Record<string, string>

let cache: ReadMap | null = null
const listeners = new Set<(state: ReadMap) => void>()

function load(): ReadMap {
  if (!cache) {
    cache = storage.getJSON<ReadMap>(STORAGE_KEY, {})
  }
  return cache
}

function notify(state: ReadMap): void {
  for (const listener of listeners) listener(state)
}

export function markConversationRead(conversationId: string): void {
  const next = { ...load(), [conversationId]: new Date().toISOString() }
  cache = next
  notify(next)
  storage.setJSON(STORAGE_KEY, next)
}

export function subscribeReadState(listener: (state: ReadMap) => void): () => void {
  listeners.add(listener)
  listener(load())
  return () => {
    listeners.delete(listener)
  }
}

export function getCachedReadState(): ReadMap {
  return load()
}

export function clearReadState(): void {
  cache = {}
  storage.remove(STORAGE_KEY)
  notify({})
}

/** Отметки, проставленные в другой вкладке, должны быть видны и здесь. */
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return
    cache = storage.getJSON<ReadMap>(STORAGE_KEY, {})
    notify(cache)
  })
}
